/* ==========================================================================
   MONDSEE — GoldFi Structure
   Behavioural patches. Loaded site-wide from layout/theme.liquid.

   Everything here is deliberately ADDITIVE and attaches from the outside, so
   snippets/mondsee-extras.liquid (Rey's file — sparkle cursor, exit popup,
   sticky ATC, free-shipping bar) is never edited. Do not move this logic into
   that snippet.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Exit-popup email capture

     The popup in mondsee-extras.liquid promises "Enter your email and we'll
     send your code right away", but its submit handler calls preventDefault()
     and paints the WELCOME10 code straight into the DOM. The email value is
     never sent anywhere — every signup was being discarded.

     This listener is registered on the document in the CAPTURE phase, so it
     always runs before that bubble-phase handler. It posts the address to
     Shopify's own customer endpoint (the same mechanism the homepage
     newsletter form uses) and then gets out of the way, leaving the existing
     success state untouched.
     ------------------------------------------------------------------------ */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.id !== 'mnd-popup-form') return;

      var input = form.querySelector('input[type="email"]');
      var email = input && input.value ? input.value.trim() : '';
      if (!email) return;

      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter,exit-popup');

      try {
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        })['catch'](function () {});
      } catch (err) {
        /* never block the popup's own success state */
      }
    },
    true
  );
})();
